module.exports = __webpack_public_path__ + "img/Referenzen_FrankfurtAirport.7da24d06.jpg";